"use client";

import Tooltip from "@mui/material/Tooltip";
import { Files } from "lucide-react";

import { useStyles } from "./styles";
import { useAppDispatch } from "@/redux/store";
import { generateAlert } from "@/redux/actions";

interface CopyPromptProps {
  prompt: string;
}

const CopyPrompt: React.FC<CopyPromptProps> = ({ prompt }) => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();

  const handleCopyPrompt = () => {
    navigator.clipboard.writeText(prompt);
    dispatch(
      generateAlert({ text: "Prompt copied to clipboard", type: "success" })
    );
  };

  if (!prompt) return null;

  return (
    <Tooltip title="Copy Prompt" arrow placement="top">
      <button
        className={classes.copyButton}
        onClick={handleCopyPrompt}
        aria-label="Copy Prompt"
      >
        <Files size={16} />
      </button>
    </Tooltip>
  );
};

export default CopyPrompt;
